import React, { useEffect } from 'react'
import { Button, Form, Input, Modal } from 'antd'
import validator from '../../../validator'
import createISOFolderStore from './createISOFolderStore'
import { observer } from 'mobx-react'
import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined'

const CreateISOFolderModal = props => {
  const { visible, parentFolderId, onClose } = props
  const { isLoading } = createISOFolderStore
  const [form] = Form.useForm()

  useEffect(() => {
    console.log('isLoading', isLoading)

    return () => {
      createISOFolderStore.clearStore()
    }
  }, [])

  const onFinish = async values => {
    console.log('onFinish', values)
    const { folder_name } = values

    await createISOFolderStore.create(folder_name, parentFolderId)

    closeAndResetForm()
  }

  const closeAndResetForm = () => {
    form.resetFields()
    onClose()
  }

  return (
    <>
      <Modal
        wrapClassName="custom-modal-wrapper"
        footer={null}
        closable={true}
        visible={visible}
        onCancel={() => {
          closeAndResetForm()
        }}
        title="Tạo thư mục">
        <Form form={form} layout={'vertical'} onFinish={onFinish}>
          <Form.Item
            name={'folder_name'}
            rules={[
              { required: true, message: 'Vui lòng nhập tên thư mục!' },
              { validator: validator.validateInputString },
            ]}
            label={'Tên thư mục:'}>
            <Input placeholder={'Nhập tên thư mục'} />
          </Form.Item>
          {/* 
          <Form.Item>
            <Button
              icon={<PlusOutlined />}
              loading={isLoading}
              htmlType={'submit'}
              type={'primary'}>
              Tạo
            </Button>
          </Form.Item> */}

          <div className="custom-modal-footer">
            <Button
              type="default"
              onClick={() => {
                closeAndResetForm()
              }}
              htmlType="reset"
              className="custom-ant-button w-160">
              Hủy bỏ
            </Button>
            <Button
              loading={isLoading}
              htmlType={'submit'}
              type={'primary'}
              className="custom-ant-button w-160">
              Tạo mới
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  )
}

export default observer(CreateISOFolderModal)
